export const ZENU_EMAIL_TEMPLATE = {
  to: 'support@zenu.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello Zenu

Could you please enable Snug as an upload destination for our agency for the Zenu Account(s):

- [Enter your Agency ID here]

Please assign the Zenu Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
